<div class="mobile_header" [class.addr_open]="showMobileAddressSelection">
  <app-top-navbar
    [currentType]="currentType"
    [favoriteValue]="favoriteValue"
    (changeType)="currentType = $event"
    [selectedData]="cityControl"
    (selectAddressToDeliverEvent)="openDialogOrBottomSheetAddressSelect($event)"
    [showMobileAddressSelection]="showMobileAddressSelection"
    (mobileAddressConfirmed)="onMobileAddressConfirmed($event)"
    (mobileAddressClosed)="onMobileAddressClosed()"
  ></app-top-navbar>
  <app-bottom-navbar-for-address-selection *ngIf="currentType === mobileNavigationBackButtonTypeEnum.TWO_PART_HEADER_WITH_SEARCH_AND_ADDRESS_SELECTION"
                     [selectedData]="cityControl"
                     (selectAddressToDeliverEvent)="openDialogOrBottomSheetAddressSelect($event)"
  ></app-bottom-navbar-for-address-selection>
  <app-show-default-address-to-change
    *ngIf="defaultAddressIsSelected"
    (closeDialog)="handleDialogClose($event)"
  ></app-show-default-address-to-change>
</div>
